import {
    AddOutlined,
    RemoveOutlined,
    ShoppingCart,
    ShoppingCartOutlined,
  } from "@mui/icons-material";
  import { Button, IconButton, Stack, Typography,Grid } from "@mui/material";
  import { Box } from "@mui/system";
  import React from "react";
  import { Link, useHistory } from "react-router-dom";
  import "./Cart.css";
  
  // Definition of Data Structures used
  /**
   * @typedef {Object} Product - Data on product available to buy
   * 
   * @property {string} name - The name or title of the product
   * @property {string} category - The category that the product belongs to
   * @property {number} cost - The price to buy the product
   * @property {number} rating - The aggregate rating of the product (integer out of five)
   * @property {string} image - Contains URL for the product image
   * @property {string} _id - Unique ID for the product
   */
  
  /**
   * @typedef {Object} CartItem -  - Data on product added to cart
   * 
   * @property {string} name - The name or title of the product in cart
   * @property {string} qty - The quantity of product added to cart
   * @property {string} category - The category that the product belongs to
   * @property {number} cost - The price to buy the product
   * @property {number} rating - The aggregate rating of the product (integer out of five)
   * @property {string} image - Contains URL for the product image
   * @property {string} productId - Unique ID for the product
   */
  
  /**
   * Returns the complete data on all products in cartData by searching in productsData
   *
   * @param { Array.<{ productId: String, qty: Number }> } cartData
   *    Array of objects with productId and quantity of products in cart
   * 
   * @param { Array.<Product> } productsData
   *    Array of objects with complete data on all available products
   *
   * @returns { Array.<CartItem> }
   *    Array of objects with complete data on products in cart
   *
   */
  export const generateCartItemsFrom = (cartData=[], productsData) => {
    let cartItems =[];
    cartData?.forEach((item)=>{
        const {product:cProduct}=item;
        productsData.forEach((product)=>{
          console.info(item,"item");
          console.info(product,"product");
            if(product._id === cProduct._id){
                cartItems.push({...item,...product});
            }
        })
    });
    return cartItems;
  };
  
  /**
   * Get the total value of all products added to the cart
   *
   * @param { Array.<CartItem> } items
   *    Array of objects with complete data on products added to the cart
   *
   * @returns { Number }
   *    Value of all items in the cart
   *
   */
  export const getTotalCartValue = (items = []) => {
    let totCost =0;
    items.forEach((item)=>{
        const {quantity,cost}=item;
        totCost += quantity*cost;
    });
    return totCost;
  };
  
  const getTotalItems =(items)=>{
    return <Grid container >
     <Grid item xs={12} sx={{display:'flex',padding:'0.5em 1em'}}>
      <Typography>Product</Typography>
      <div style={{display:'flex',justifyContent:'flex-end',flex:1}}>
       <Typography >{items.length}</Typography>
      </div>
     </Grid>
     <Grid item xs={12} sx={{display:'flex',padding:'0.5em 1em'}}>
      <Typography>Subtotal</Typography>
      <div style={{display:'flex',justifyContent:'flex-end',flex:1}}>
       <Typography >{`$${getTotalCartValue(items)}`}</Typography>
      </div>
     </Grid>
     <Grid item xs={12} sx={{display:'flex',padding:'0.5em 1em'}}>
      <Typography>Shipping Charges</Typography>
      <div style={{display:'flex',justifyContent:'flex-end',flex:1}}>
       <Typography >{'$0'}</Typography>
      </div>
     </Grid>
     <Grid item xs={12} sx={{display:'flex',padding:'0.5em 1em'}}>
      <Typography sx={{fontWeight:800}}>Total</Typography>
      <div style={{display:'flex',justifyContent:'flex-end',flex:1}}>
       <Typography sx={{fontWeight:800}}>{`$${getTotalCartValue(items)}`}</Typography>
      </div>
     </Grid>
    </Grid>
  };
  
  /**
   * Component to display the current quantity for a product and + and - buttons to update product quantity on cart
   * 
   * @param {Number} value
   *    Current quantity of product in cart
   * 
   * @param {Function} handleAdd
   *    Handler function which adds 1 more of a product to cart
   * 
   * @param {Function} handleDelete
   *    Handler function which reduces the quantity of a product in cart by 1
   * 
   * @param {Boolean} isReadOnly
   *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
   * 
   */
  const ItemQuantity = ({
    value,
    handleAdd,
    handleDelete,
  }) => {
    return (
      <Stack direction="row" alignItems="center">
        <IconButton size="small" color="primary" onClick={handleDelete}>
          <RemoveOutlined />
        </IconButton>
        <Box padding="0.5rem" data-testid="item-qty">
          {value}
        </Box>
        <IconButton size="small" color="primary" onClick={handleAdd}>
          <AddOutlined />
        </IconButton>
      </Stack>
    );
  };
  
  /**
   * Component to display the Cart view
   * 
   * @param { Array.<Product> } products
   *    Array of objects with complete data of all available products
   * 
   * @param { Array.<Product> } items
   *    Array of objects with complete data on products in cart
   * 
   * @param {Function} handleDelete
   *    Current quantity of product in cart
   * 
   * @param {Boolean} isReadOnly
   *    If product quantity on cart is to be displayed as read only without the + - options to change quantity
   * 
   */
  const Cart = ({
    products,
    items = [],
    handleQuantity,
    isReadOnly
  }) => {
  
    if (!items.length) {
      return (
        <Box className="cart empty">
          <ShoppingCartOutlined className="empty-cart-icon" />
          <Box color="#aaa" textAlign="center">
            Cart is empty. Add more items to the cart to checkout.
          </Box>
        </Box>
      );
    }
  
    return (
      <>
        <Box className="cart">
          {/* TODO: CRIO_TASK_MODULE_CART - Display view for each cart item with non-zero quantity */}
          {
            items.map((item,index)=>{
                if(item.quantity < 1 ){
                  return ''
                }
                return <Box key={`${item._id}-${index}`} display="flex" alignItems="flex-start" padding="1rem">
                    <Box className="image-container">
                        <img
                            // Add product image
                            src={item.image}
                            // Add product name as alt eext
                            alt={item.name}
                            width="100%"
                            height="100%"
                        />
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                        height="6rem"
                        paddingX="1rem"
                    >
                        <div>{item.name}</div>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                        {isReadOnly ? <Box>
                          {`Qty:${item.quantity}`}
                        </Box>:<ItemQuantity value={item.quantity} handleAdd={() => handleQuantity('add',item)} handleDelete={() => handleQuantity('remove',item)}
                        // Add required props by checking implementation
                        />}
                        <Box padding="0.5rem" fontWeight="700">
                            ${item.cost}
                        </Box>
                        </Box>
                    </Box>
                </Box>
            })
          }
          <Box
            padding="1rem"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box color="#3C3C3C" alignSelf="center">
              Order total
            </Box>
            <Box
              color="#3C3C3C"
              fontWeight="700"
              fontSize="1.5rem"
              alignSelf="center"
              data-testid="cart-total"
            >
              ${getTotalCartValue(items)}
            </Box>
          </Box>
  
          {!isReadOnly && <Box display="flex" justifyContent="flex-end" className="cart-footer">
            <Link className="link" to='/checkout'>
            <Button
              color="primary"
              variant="contained"
              startIcon={<ShoppingCart />}
              className="checkout-btn"
            >
              Checkout
            </Button>
            </Link>
          </Box>}
        </Box>
        {isReadOnly && <Box className="cart">
          <Typography style={{padding:'1em',fontWeight:800}}>Order Details</Typography>
          {getTotalItems(items)}
        </Box>}
      </>
    );
  };
  
  export default Cart;
  